import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { BodyText, Card, Icon, withStyles } from 'vopay';
import { Title, CircleButton, Button } from 'UI';
import styles from './UpgradePlanCardDialog.module.scss';
import { useTranslation } from 'react-i18next';

type UpgradePlanCardDialogProps = {
  onCancel: () => void;
};

const cn = withStyles(styles);

const UpgradePlanCardDialog: FC<UpgradePlanCardDialogProps> = ({ onCancel }) => {
  const history = useHistory();
  const { t } = useTranslation('translations', {
    keyPrefix: 'Customers.PaymentMethodsTab.Details.Verification.UpgradePlanCardDialog',
  });

  return (
    <Card className={cn('modalContainer')}>
      <Title level="3">{t('title', { defaultValue: 'Upgrade Your Card Plan!' })}</Title>

      <div className={cn('closeButton')}>
        <CircleButton icon="close" size="large" circleFill onClick={onCancel} />
      </div>

      <BodyText className={cn('description')}>
        {t('description', {
          defaultValue:
            'Confirm ownership and registration details retrieved from card processor records for this contact.',
        })}
      </BodyText>

      <div className={cn('plans')}>
        <div className={cn('plan', 'basic')}>
          <Icon icon="checkBlueGradient" width="80px" height="80px" color="none" />

          <div>
            <Title level="5">{t('basicTitle', { defaultValue: 'Basic' })}</Title>

            <BodyText className={cn('text')}>
              {t('basicDescription', { defaultValue: 'Verify the ownership of the card holder.' })}
            </BodyText>
          </div>
        </div>

        <div className={cn('plan', 'enhanced')}>
          <Icon icon="iconsEnhancedCard" width="80px" height="80px" color="none" />

          <div>
            <Title className={cn('title')} level="5">
              {t('enhancedTitle', { defaultValue: 'Enhanced' })}
            </Title>

            <BodyText className={cn('text')}>
              {t('enhancedDescription', {
                defaultValue: 'Confirm ownership and access registration details retrieved from card processor.',
              })}
            </BodyText>
          </div>
        </div>
      </div>

      <Button
        className={cn('button')}
        colorScheme="primary"
        onClick={() => {
          onCancel();

          history.push({
            pathname: '/create-tickets',
            state: {
              ticketSubject: t('ticketSubject', { defaultValue: 'Enquiry about Card Verification' }),
            },
          });
        }}
      >
        {t('contactSupportButton', { defaultValue: 'Contact Support' })}
      </Button>
    </Card>
  );
};

export default UpgradePlanCardDialog;
